<template>
	<div class="page_box">
		<el-pagination
			class="paginationsd"
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-size="PageSize"
			:total="index"
			background
			layout="prev, pager, next"
		></el-pagination>
	</div>
</template>

<script>
export default {
	props: {
		index: Number
	},
	data() {
		return {
			// 总数据
			tableData: [],
			// 默认显示第几页
			currentPage: 1,
			// 总条数，根据接口获取数据长度(注意：这里不能为空)
			// totalCount:100,
			// 默认每页显示的条数（可修改）
			PageSize: 10
		};
	},
	methods: {
		handleSizeChange(val) {
			// 改变每页显示的条数
			this.PageSize = val;
			// 注意：在改变每页显示的条数时，要将页码显示到第一页
			this.currentPage = 1;
		},
		// 显示第几页
		handleCurrentChange(val) {
			// 改变默认的页数
			this.currentPage = val;
			this.$emit('get', this.currentPage);
		}
	}
};
</script>
<style scoped>
.div {
	display: table;
	margin: 0px auto;
}
.el-pagination.is-background .el-pager li:not(.disabled)/deep/.active {
	background: red !important;
}
.paginationsd {
	/* margin: 0 0 0 -30px; */
	display: table-cell;
}
.page_box {
	position: absolute;
	bottom: 0;
	background-color: #ffffff;
	z-index: 99;
	min-width: 1200px;
	/* max-width: 1200px; */
	display: flex;
	justify-content: center;
}
>>>.el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #00AF63;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination/pagination.vue